// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Select extends Component {
  render() {
    const {
      customClasses,
      inputClassName,
      name,
      options,
      placeholder,
      label,
      handleChange,
      disabled,
      isRequired,
    } = this.props;

    return (
      <div className={classNames('form__select-field', customClasses)}>
        {label && <label className="form__select-field-label">{label}</label>}
        <select
          className={classNames('form__select-field-input', inputClassName)}
          name={name}
          onChange={handleChange}
          disabled={disabled}
          required={isRequired}
          data-bouncer-target={isRequired ? `#invalid-${name}` : ''}
        >
          {placeholder && (
            <option value="" selected disabled>
              {placeholder}
            </option>
          )}
          {options &&
            options.map(option => (
              <option
                className="form__select-field-option"
                value={option.value}
                selected={option.selected}
              >
                {option.label}
              </option>
            ))}
        </select>

        {isRequired && (
          <div id={`invalid-${name}`} className="invalid-feedback" />
        )}
      </div>
    );
  }
}

Select.defaultProps = {
  isRequired: false,
};

Select.propTypes = {
  customClasses: PropTypes.string,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(),
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
};
